function LoggedUserDirective($compile, LoginService) {
    'ngInject';

    return {
        transclude: true,
        scope: {},
        // tell Angular to stop compiling after that (on the same directive)
        terminal: true,
        restrict: 'A',
        priority: 10000,
        compile: function compile(element, attrs) {
            /*
             * Avoid indefinite loop. Otherwise Angular tries
             * to infinitely recompile the directive itself
             */
            element.removeAttr('add-condition');
            element.removeAttr('data-add-condition');

            // remove the directive attribute
            element.removeAttr('bb-logged-user');

            return {
                post: function postLink(scope, iElement, iAttrs, controller, transcluded) {
                    /*
                     * Retrieve the directive child/ren content.
                     *
                     * The directive content is removed during the compiling process
                     * so we have to re-add it again
                     */
                    transcluded(scope, (clone) => {

                        // set the condition we need to show/hide the content
                        iElement[0].setAttribute('ng-if', '$root.member');

                        LoginService.checkLogin();

                        // all children are translated into string to set inner html
                        iElement[0].innerHTML = clone.map((index, c) => {
                            return c.outerHTML || null;
                        }).get().join('');

                        // recompile
                        $compile(iElement)(scope);
                    });
                }
            };
        }
    };
}

/**
 * This directive allows to use the bb-logged-user attribute to show some
 * content only if the user is logged in.
 *
 * You can transclude the directive children content as well.
 *
 * You can use this directive anywhere you need to show or hide a content
 * conditionally for a logged in user.
 *
 * Example:
 *
 * <div bb-logged-user>
 *     <span>some content for the logged in user only</span>
 *     <p>only an authenticated user can see me</span>
 * </div>
 *
 * The block above is rendered only if the user logs in or is already logged in.
 * The directive handles the runtime login status changes as well
 *
 * @param $compile
 * @param LoginService
 * @returns {{transclude: boolean, scope: {}, terminal: boolean, restrict: string, priority: number, compile: compile}}
 */
angular
    .module('BBMember')
    .directive('bbLoggedUser', LoggedUserDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/logged-user/logged_user.directive.js